<template>
  <div class="form" style="text-align:left;">
    <div class="title is-4">{{ title }}</div>


    <div class="columns">
      <div class="column" style="text-align:left;">
        <packageproduktionsverfahrenselect :selected="item.packageProductions"
                                           @input="setPackageProductions($event)"></packageproduktionsverfahrenselect>
      </div>
      <div class="column">

      </div>
    </div>


    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Name">
          <b-input maxlength="255" v-model="item.name"></b-input>
        </b-field>
      </div>
      <div class="column" style="text-align:left;">
        <b-field label="Interner Name">
          <b-input maxlength="255" v-model="item.internalName"></b-input>
        </b-field>
      </div>
      <div class="column">

      </div>
    </div>
    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Gestaltungsleitfaden">
          <b-input size="is-small" readonly="true" v-model="item.gestaltungsleitfaden"></b-input>
        </b-field>
      </div>
    </div>
    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Bild">
          <b-input maxlength="255" v-model="item.image"></b-input>
        </b-field>
      </div>
      <div class="column">
        <label class="label">Ausstattungen</label>
        <equipmentSelect :value="item.packageEquipments" @input="setEquipments($event)"></equipmentSelect>
      </div>
    </div>
    <div class="columns">
      <div class="column is-half" style="text-align:left;">
        <label class="label">Beschreibung Frontend</label>
        <VueTrix maxlength="255" v-model="item.frontendDescription" placeholder="Beschreibung Frontend"/>
      </div>
      <div class="column is-half" style="text-align:left;">
        <label class="label">Beschreibung Angebot</label>
        <VueTrix maxlength="255" v-model="item.description" placeholder="Beschreibung Angebot"/>
      </div>
    </div>
    <div class="columns">
      <div class="column is-half">
        <b-field label="Code">
          <b-input maxlength="255" v-model="item.code"></b-input>
        </b-field>
      </div>
      <div class="column  is-half">
        <b-field label="Sortierung">
          <b-numberinput v-model="item.frontendorder"></b-numberinput>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column" style="text-align:right;">
        <b-button type="is-primary" v-on:click="save()" :disabled="loading">Speichern</b-button>
      </div>
    </div>

  </div>
</template>


<script>
// @ is an alias to /src
import packageproduktionsverfahrenselect from "@/components/PackageProduktionsVerfahrenSelect.vue";
import equipmentSelect from "@/components/EquipmentSelect.vue";

import Vue from 'vue'
import VueTrix from "vue-trix";

const axios = require('axios');


export default {
  name: "home",
  components: {
    packageproduktionsverfahrenselect,
    VueTrix,
    equipmentSelect
  },
  data() {
    return {
      title: "Neue Verpackung anlegen",
      item: {},
      loading: true,
      //  item: { 'id': 22, 'name': 'Beidseitig individuelles Kartenset', 'spielart': 'Kartenspiel', 'date': '2016-10-15 13:43:27' },
    }
  },
  watch: {},
  mounted: function () {
    console.log("FORM " + this.$route.params.id);
    if (this.$route.params.id) {
      this.title = "Verpackung bearbeiten";
      //Get-Game
      var _this = this;
      axios.get('/api/packagesnew/' + this.$route.params.id, {
        withCredentials: true,
      })
          .then(function (response) {
            console.log(response.data);
            _this.item = response.data;
            _this.loading = false;

          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
            // always executed
          });
    } else {
      this.loading = false;
    }

  },
  methods: {
    setPackageProductions: function (val) {
      console.log("setPackageProductions");
      console.log(val);
      this.$set(this.item, "packageProductions", val)
    },
    setEquipments: function (val) {
      console.log("setEquipments");
      console.log(val);
      this.$set(this.item, "packageEquipments", val)
    },
    save: function () {
      if ((this.item.packageProductions) && (this.item.name) && (this.item.internalName) && (this.item.description) && (this.item.frontendDescription) && (this.item.image) && (this.item.code)) {

        //Set-Package
        var _this = this;
        var url = '/api/packagesnew';


        console.log("SAVE");
        console.log(url);
        console.log(this.item);
        // Equipment items umwandeln
        this.item.packageEquipments = this.item.packageEquipments.map(el => {
          if (el.id) {
            return {"id": el.id}
          } else {
            return {"id": el}
          }
        })

        axios.post(url, this.item, {
          headers: {
            'Content-Type': 'application/json',
          },
          withCredentials: true,
        })
            .then(function (response) {
              console.log(response.data);
              _this.$router.push({name: 'packages'})
            })
            .catch(function (error) {
              console.log(error);
            })
            .then(function () {
              // always executed
            });

      } else {
        console.log("Alle Felder ausfüllen");
        this.$buefy.dialog.alert({
          title: 'Fehler',
          message: 'Bitte füllen Sie alle Felder aus. Mindestens ein Produktionsverfahren muss ausgefüllt sein.',
          type: 'is-danger',
          hasIcon: true,
          icon: 'alert-circle',
          iconPack: 'mdi'
        });

      }

    }
  }
};

</script>
